import { StyleSheet, UnistylesRuntime } from "react-native-unistyles";

const stylesheet = StyleSheet.create(({ spacing, colors, border }) => ({
  grid: {
    _web: {
      display: "grid",
      gridTemplateColumns: {
        xs: "repeat(auto-fill, minmax(12rem, 1fr))",
        lg: "repeat(auto-fill, minmax(16rem, 1fr))",
      },
      gap: spacing(4),
    },
  },
  pressable: {
    _web: {
      _focus: {
        outline: "none",
      },
      "_focus-visible": {
        outlineStyle: "solid",
        outlineColor: colors.borderFocus,
        outlineWidth: border.widths.xl,
        outlineOffset: border.widths.xl,
        borderRadius: border.radius.md,
      },
    },
  },
  card: {
    aspectRatio: 2 / 3,
  },
}));

const initialTheme = UnistylesRuntime.getTheme();

export const IMAGE_DIMENSIONS = {
  card: [
    {
      width: initialTheme.spacing(48),
      height: initialTheme.spacing(48) * (3 / 2),
    }, // for 2:3, xs
    {
      width: initialTheme.spacing(64),
      height: initialTheme.spacing(64) * (3 / 2),
    }, // for 2:3, lg
  ],
};

export default stylesheet;
